// PDF export via the browser's print-to-PDF (no paid Browser Rendering needed).
// Opens a dedicated print view that renders the whole document and prints it.

import { Button } from "../components/ui";

export function ExportPanel({ projectId }: { projectId: string }) {
  function openPrint() {
    window.open(`${window.location.origin}/project/${projectId}/print`, "_blank", "noopener");
  }
  return (
    <div className="card row-between">
      <div>
        <strong>Export</strong>
        <div className="muted">
          Opens a print-ready view — use your browser's “Save as PDF” to download (includes charts & images).
        </div>
      </div>
      <div className="grow" />
      <Button onClick={openPrint}>Export / Save as PDF</Button>
    </div>
  );
}
